import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import { ButtonStyled } from '@nike/nike-design-system-components';
var WishlistItemAddedModalActions = function WishlistItemAddedModalActions() {
  var $ = _c(4);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      stringKey: "addToCart.modal.cta.viewFavorites",
      primaryValue: "View Favorites",
      description: "button label for add to cart modal add to favorites"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var viewFavoritesString = useI18nString(t0);
  var t1;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    var _window$NikeShop;
    t1 = (_window$NikeShop = window.NikeShop) === null || _window$NikeShop === void 0 || (_window$NikeShop = _window$NikeShop.get()) === null || _window$NikeShop === void 0 ? void 0 : _window$NikeShop.favoritesHref;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var t2;
  if ($[2] !== viewFavoritesString) {
    t2 = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ButtonStyled, {
      appearance: "primary",
      size: "large",
      type: "button",
      Component: "a",
      href: t1,
      "data-automation": "wishlist-item-added-modal-view-favorites-button"
    }, viewFavoritesString));
    $[2] = viewFavoritesString;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default WishlistItemAddedModalActions;